var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleBusinessIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.5,
    height: 40.5,
    viewBox: "0 0 40.5 40.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1612",
    "data-name": "Rectangle 1612",
    width: 23.58,
    height: 23.483,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4749",
    "data-name": "Group 4749",
    transform: "translate(-1107.75 -159.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle",
    transform: "translate(1108 160)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_232",
    "data-name": "Ellipse 232",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#dce1e9",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(1116.21 169.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4748",
    "data-name": "Group 4748",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M.021,17.608A.25.25,0,0,1,0,17.472Q0,9.341,0,1.21A1.235,1.235,0,0,1,.931.019,1.088,1.088,0,0,1,1.166,0c.262,0,.524,0,.786,0H16.61a1.125,1.125,0,0,1,1.024.872,1.4,1.4,0,0,1,.032.311q0,5.3,0,10.6a1.071,1.071,0,0,1-.232.653,1.105,1.105,0,0,1-.653.461.855.855,0,0,1-.17.024c-.136,0-.273,0-.409,0q-5.638,0-11.276,0a.513.513,0,0,0-.39.162Q2.41,15.216.279,17.344c-.084.084-.137.2-.257.264M2.334,10.56c.019.013.036.035.053.035q6.423,0,12.846.006a.128.128,0,0,0,.1-.025c.027-.163.022-8.132-.005-8.248-.057-.052-.129-.033-.195-.033H2.445a.109.109,0,0,0-.112.05Z",
    transform: "translate(0 0.001)",
    fill: "#3a77e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M37.513,47.928c.586,0,1.151,0,1.715,0h13.6c.005-.436,0-.88,0-1.323s0-.881,0-1.321V37.329a.21.21,0,0,1,.156-.034c.713,0,1.426,0,2.139,0a1.231,1.231,0,0,1,.753.226,1.167,1.167,0,0,1,.467.82,4.049,4.049,0,0,1,0,.563q0,2.98,0,5.96,0,5.007,0,10.014c0,.345.014.689.02,1.034a.344.344,0,0,1-.014.167c-.057,0-.077-.038-.1-.066q-2.206-2.208-4.41-4.419a.518.518,0,0,0-.4-.166q-3.192.009-6.385.007H38.779a1.185,1.185,0,0,1-1.236-1,2.383,2.383,0,0,1-.031-.453c0-.624,0-1.247,0-1.871v-.187",
    transform: "translate(-32.792 -32.602)",
    fill: "#3a77e7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleBusinessIcon);
export default __webpack_public_path__ + "static/media/google-business-icon.29dffd4b18ba88b197abe25c083174c2.svg";
export { ForwardRef as ReactComponent };